import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import SVG from 'react-inlinesvg';
import ConsultantInterest from '../../ConsultantInterest';
import capitalize from '../../../stringUtils';
import { putRequest } from '../../../requestUtils';
import caretDown from '../../../../assets/images/carat.svg';
import caretUp from '../../../../assets/images/chevronUp.svg';
var statusDisplay = function statusDisplay(status, cloraRep) {
  if (!cloraRep && status === 'pending_rep_review') {
    return 'invitation_sent';
  }
  return status;
};
function TableDisplay(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Title' : _ref$title,
    tableContents = _ref.tableContents,
    csrfToken = _ref.csrfToken,
    _ref$count = _ref.count,
    count = _ref$count === void 0 ? 0 : _ref$count,
    _ref$proposalOrProjec = _ref.proposalOrProjectInv,
    proposalOrProjectInv = _ref$proposalOrProjec === void 0 ? 'proposal' : _ref$proposalOrProjec,
    employmentType = _ref.employmentType,
    _ref$projectResourceI = _ref.projectResourceId,
    projectResourceId = _ref$projectResourceI === void 0 ? '' : _ref$projectResourceI,
    projectsOptions = _ref.projectsOptions,
    isCollaborator = _ref.isCollaborator,
    cloraRepName = _ref.cloraRepName,
    _ref$cloraRep = _ref.cloraRep,
    cloraRep = _ref$cloraRep === void 0 ? false : _ref$cloraRep,
    _ref$onApproved = _ref.onApproved,
    onApproved = _ref$onApproved === void 0 ? function () {} : _ref$onApproved;
  var _useState = useState(tableContents),
    _useState2 = _slicedToArray(_useState, 2),
    applications = _useState2[0],
    setApplications = _useState2[1];
  var _useState3 = useState(5),
    _useState4 = _slicedToArray(_useState3, 2),
    showMore = _useState4[0],
    setShowMore = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    appIds = _useState6[0],
    setAppIds = _useState6[1];
  var _useState7 = useState({}),
    _useState8 = _slicedToArray(_useState7, 2),
    drafts = _useState8[0],
    setDrafts = _useState8[1];
  var _useState9 = useState({}),
    _useState10 = _slicedToArray(_useState9, 2),
    sending = _useState10[0],
    setSending = _useState10[1];
  var activeProposalsOrApplications = proposalOrProjectInv === 'proposal' || title === 'Applications';
  useEffect(function () {
    setApplications(tableContents);
  }, [tableContents]);
  var isProposal = proposalOrProjectInv === 'proposal';
  var handleInterestCallback = function handleInterestCallback(interest, status) {
    var newApplications = _toConsumableArray(applications);
    var modifiedInterest = newApplications.find(function (app) {
      return app.id === interest.id;
    });
    var newModifiedInterest = _objectSpread(_objectSpread({}, modifiedInterest), {}, {
      status: status,
      interest: interest
    });
    // replace the modified interest at the same index to avoid confusion
    newApplications[newApplications.indexOf(modifiedInterest)] = newModifiedInterest;
    setApplications(newApplications);
  };
  var handleShowLess = function handleShowLess() {
    if (showMore > 9) {
      setShowMore(showMore - 5);
    }
  };
  var toggleCustomeMessage = function toggleCustomeMessage(id) {
    var updatedAppIds = appIds.includes(id) ? appIds.filter(function (v) {
      return v !== id;
    }) : [].concat(_toConsumableArray(appIds), [id]);
    setAppIds(updatedAppIds);
  };
  var renderConsultantName = function renderConsultantName(application) {
    if (application.model_name === 'ConsultantInterest') {
      return /*#__PURE__*/React.createElement("a", {
        className: "review",
        href: "".concat(application.consultant_link),
        role: "button",
        target: "_blank",
        rel: "noreferrer"
      }, application.consultant_name);
    }
    return application.consultant_name;
  };
  var renderLink = function renderLink(application) {
    if (['ProjectInvitation', 'Proposal'].includes(application.model_name)) {
      return /*#__PURE__*/React.createElement("a", {
        className: "review",
        href: "".concat(isProposal ? application.link : application.consultant_link),
        role: "button",
        target: "_blank",
        rel: "noreferrer"
      }, isProposal ? 'Review' : 'View Profile');
    }
    var interest_details = application.interest_details;
    return /*#__PURE__*/React.createElement(ConsultantInterest, {
      key: interest_details.interest_id,
      interest: {
        accepted: application.status === 'accepted',
        rejected: application.status === 'rejected',
        waitlisted: application.status === 'waitlisted',
        id: interest_details.interest_id,
        consultant_name: application.consultant_name,
        project_name: application.project_name || 'this project',
        update_state_url: interest_details.update_state_url,
        response_templates: interest_details.response_templates
      },
      interestId: interest_details.interest_id,
      createProposalPath: interest_details.create_proposal_path,
      csrfToken: csrfToken,
      rep: interest_details.rep,
      clorifyUrl: interest_details.clorify_url,
      rejectedCallback: function rejectedCallback(interest) {
        handleInterestCallback(interest, 'rejected');
      },
      waitlistedCallback: function waitlistedCallback(interest) {
        handleInterestCallback(interest, 'waitlisted');
      },
      acceptedCallback: function acceptedCallback(interest) {
        handleInterestCallback(interest, 'accepted');
      },
      projectResourceId: projectResourceId,
      projectsOptions: projectsOptions,
      cloraRepName: cloraRepName,
      showInProposalsTab: true
    });
  };
  var showProposalsOrApplication = function showProposalsOrApplication() {
    return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("thead", {
      className: "outer-thead"
    }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
      className: "outer-cn-th"
    }, "Consultant name"), /*#__PURE__*/React.createElement("th", {
      className: "empty-th"
    }), !isCollaborator && employmentType === 'consulting' ? /*#__PURE__*/React.createElement("th", {
      className: "outer-th"
    }, "Hourly Rate") : '', /*#__PURE__*/React.createElement("th", {
      className: "outer-th"
    }, "Last Updated"), /*#__PURE__*/React.createElement("th", {
      className: "outer-th"
    }, "Status"))), /*#__PURE__*/React.createElement("tbody", {
      className: "outer-tbody"
    }, applications.slice(0, showMore).map(function (application) {
      return /*#__PURE__*/React.createElement("tr", {
        className: "outer-tr",
        key: "app-".concat(application.id)
      }, /*#__PURE__*/React.createElement("td", {
        className: "outer-cn-td"
      }, renderConsultantName(application)), /*#__PURE__*/React.createElement("td", {
        className: "outer-td"
      }, renderLink(application)), !isCollaborator && employmentType === 'consulting' ? /*#__PURE__*/React.createElement("td", {
        className: "outer-td"
      }, "$", application.amount) : '', /*#__PURE__*/React.createElement("td", {
        className: "outer-td"
      }, application.last_updated), /*#__PURE__*/React.createElement("td", {
        className: "outer-td"
      }, /*#__PURE__*/React.createElement("span", {
        className: "status status-".concat(application.status)
      }, capitalize(application.status))));
    })));
  };
  var showProjectInvitation = function showProjectInvitation() {
    return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("thead", {
      className: "outer-thead"
    }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
      colSpan: 4
    }, /*#__PURE__*/React.createElement("table", {
      className: "inner-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("th", {
      className: "inner-cn-th"
    }, "Consultant name"), /*#__PURE__*/React.createElement("th", {
      className: "empty-th"
    }), /*#__PURE__*/React.createElement("th", {
      className: "inner-th"
    }, "Last Updated"), /*#__PURE__*/React.createElement("th", {
      className: "inner-th"
    }, "Status")))))), /*#__PURE__*/React.createElement("tbody", {
      className: "outer-tbody"
    }, applications.slice(0, showMore).map(function (application) {
      return /*#__PURE__*/React.createElement("tr", {
        className: "outer-tr",
        key: "inv-".concat(application.id)
      }, /*#__PURE__*/React.createElement("td", {
        colSpan: 4
      }, /*#__PURE__*/React.createElement("table", {
        className: "inner-table"
      }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        className: "inner-cn-td"
      }, application.consultant_name), /*#__PURE__*/React.createElement("td", {
        className: "inner-td"
      }, renderLink(application)), /*#__PURE__*/React.createElement("td", {
        className: "inner-td"
      }, application.last_updated), /*#__PURE__*/React.createElement("td", {
        className: "inner-td"
      }, /*#__PURE__*/React.createElement("span", {
        className: "status status-".concat(statusDisplay(application.status, cloraRep))
      }, capitalize(statusDisplay(application.status, cloraRep))))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        colSpan: 4
      }, application.custom_message && application.status !== 'pending_rep_review' && /*#__PURE__*/React.createElement("div", {
        className: "custom-message-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "custom-message",
        style: {
          WebkitLineClamp: appIds.includes(application.id) ? null : 1
        }
      }, application.custom_message), /*#__PURE__*/React.createElement("button", {
        onClick: function onClick() {
          return toggleCustomeMessage(application.id);
        }
      }, appIds.includes(application.id) ? /*#__PURE__*/React.createElement(SVG, {
        src: caretUp,
        title: "View Less"
      }) : /*#__PURE__*/React.createElement(SVG, {
        src: caretDown,
        title: "View all"
      }))))), cloraRep && application.status === 'pending_rep_review' && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        colSpan: 4
      }, /*#__PURE__*/React.createElement("div", {
        className: "rep-approval-editor"
      }, /*#__PURE__*/React.createElement("label", {
        className: "body-text-3 medium-weight"
      }, "Message to consultant"), function () {
        var messageValue = drafts[application.id] !== undefined ? drafts[application.id] : application.custom_message || '';
        return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("textarea", {
          className: "form-control",
          rows: 4,
          value: messageValue,
          onChange: function onChange(e) {
            return setDrafts(_objectSpread(_objectSpread({}, drafts), {}, _defineProperty({}, application.id, e.target.value)));
          }
        }), /*#__PURE__*/React.createElement("div", {
          className: "d-flex justify-content-end"
        }, /*#__PURE__*/React.createElement("button", {
          className: "btn btn-primary btn-sm text-decoration-none",
          disabled: !!sending[application.id],
          onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            var msg, updated;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  setSending(_objectSpread(_objectSpread({}, sending), {}, _defineProperty({}, application.id, true)));
                  msg = messageValue;
                  _context.next = 5;
                  return putRequest("/projects/".concat(projectResourceId, "/project_invitations/").concat(application.id), {
                    status: 'invited',
                    message: msg
                  }, csrfToken);
                case 5:
                  // update local state to reflect invited status
                  updated = applications.map(function (a) {
                    return a.id === application.id ? _objectSpread(_objectSpread({}, a), {}, {
                      status: 'invited',
                      custom_message: msg
                    }) : a;
                  });
                  setApplications(updated);
                  if (onApproved) onApproved();
                case 8:
                  _context.prev = 8;
                  setSending(_objectSpread(_objectSpread({}, sending), {}, _defineProperty({}, application.id, false)));
                  return _context.finish(8);
                case 11:
                case "end":
                  return _context.stop();
              }
            }, _callee, null, [[0,, 8, 11]]);
          }))
        }, sending[application.id] ? 'Sending…' : 'Approve & Send')));
      }())))))));
    })));
  };
  var renderMobileCards = function renderMobileCards() {
    return applications.slice(0, showMore).map(function (application) {
      var statusVal = activeProposalsOrApplications ? application.status : statusDisplay(application.status, cloraRep);
      var metaParts = [];
      if (!isCollaborator && employmentType === 'consulting' && application.amount) {
        metaParts.push("$".concat(application.amount));
      }
      if (application.last_updated) metaParts.push(application.last_updated);
      return /*#__PURE__*/React.createElement("div", {
        className: "proposal-card-item",
        key: "card-".concat(application.id)
      }, /*#__PURE__*/React.createElement("div", {
        className: "proposal-card-info"
      }, /*#__PURE__*/React.createElement("div", {
        className: "proposal-card-name"
      }, application.model_name === 'ConsultantInterest' ? /*#__PURE__*/React.createElement("a", {
        href: application.consultant_link,
        target: "_blank",
        rel: "noreferrer"
      }, application.consultant_name) : application.consultant_name), metaParts.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "proposal-card-meta"
      }, metaParts.join(' • '))), /*#__PURE__*/React.createElement("div", {
        className: "proposal-card-right"
      }, /*#__PURE__*/React.createElement("span", {
        className: "status status-".concat(statusVal)
      }, capitalize(statusVal)), ['ProjectInvitation', 'Proposal'].includes(application.model_name) && /*#__PURE__*/React.createElement("a", {
        href: isProposal ? application.link : application.consultant_link,
        target: "_blank",
        rel: "noreferrer",
        "aria-label": "View"
      }, /*#__PURE__*/React.createElement("span", {
        className: "proposal-card-chevron"
      }, "\u203A"))));
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "table-container"
  }, /*#__PURE__*/React.createElement("table", {
    className: "proposal-tab-table ".concat(title.toLowerCase(), "-table")
  }, activeProposalsOrApplications ? showProposalsOrApplication() : showProjectInvitation()), /*#__PURE__*/React.createElement("div", {
    className: "proposal-card-list"
  }, renderMobileCards()), count > 5 && /*#__PURE__*/React.createElement("div", {
    className: "footer"
  }, showMore <= count && /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return setShowMore(showMore + 5);
    }
  }, "See More", /*#__PURE__*/React.createElement(SVG, {
    src: caretDown,
    title: "Show more"
  })), showMore > 9 && /*#__PURE__*/React.createElement("button", {
    onClick: handleShowLess
  }, "See Less", /*#__PURE__*/React.createElement(SVG, {
    src: caretUp,
    title: "Show less"
  }))));
}
TableDisplay.propTypes = {
  title: PropTypes.string,
  tableContents: PropTypes.arrayOf(PropTypes.shape([])).isRequired,
  csrfToken: PropTypes.string.isRequired,
  count: PropTypes.number,
  proposalOrProjectInv: PropTypes.string,
  employmentType: PropTypes.string.isRequired,
  projectsOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  projectResourceId: PropTypes.string,
  interest_details: PropTypes.shape({}),
  cloraRepName: PropTypes.string.isRequired,
  onApproved: PropTypes.func,
  cloraRep: PropTypes.bool
};
export default TableDisplay;